import { render } from "./IconDiagram.vue?vue&type=template&id=53505774"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconDiagram.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53505774"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53505774', __exports__)) {
    api.reload('53505774', __exports__)
  }
  
  module.hot.accept("./IconDiagram.vue?vue&type=template&id=53505774", () => {
    api.rerender('53505774', render)
  })

}


export default __exports__